var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.51,
    height: 44.51,
    viewBox: "0 0 44.51 44.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11690.68 -9125.813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8,0A18.8,18.8,0,1,1,0,18.8,18.8,18.8,0,0,1,18.8,0Z",
    transform: "translate(11694.68 9129.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.226,16.7h4.395V30.86h-4.395Zm2.2-7a2.523,2.523,0,1,1-2.523,2.523A2.536,2.536,0,0,1,129.423,9.7",
    transform: "translate(11575.919 9128.006)",
    fill: "#313830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.1,18.226h4.232v1.953h.081a4.555,4.555,0,0,1,4.151-2.279c4.476,0,5.29,2.93,5.29,6.755v7.732h-4.395V25.469c0-1.628,0-3.744-2.279-3.744s-2.6,1.79-2.6,3.662v7h-4.395V18.226Z",
    transform: "translate(11574.206 9126.482)",
    fill: "#313830"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkinIcon);
export default __webpack_public_path__ + "static/media/linkin-icon.168bfb7a264454017971ae1d113a546f.svg";
export { ForwardRef as ReactComponent };